module.exports = __webpack_public_path__ + "static/resume_baran-254f8bbcf5733f4f87fb0678c5a80031.pdf";